//#region src/item_card_price_option_display.ts
const ItemCardMultiPriceOptionDisplay = {
	PriceRange: "price-range",
	NameAndPrice: "name-and-price",
	NameAndPriceCollapseMatching: "name-and-price-collapse-matching",
	FirstPriceOnly: "first-price-only"
};
//#endregion
export { ItemCardMultiPriceOptionDisplay };

//# sourceMappingURL=item_card_price_option_display.js.map